import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Prices from "./pages/Prices";
import TOS from "./pages/TOS";
import Gallery from "./pages/Gallery";
import Queue from "./pages/Queue";
import Feedback from "./pages/Feedback";
import Commission from "./pages/Commission";
import DiscountOptions from "./pages/DiscountOptions";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div className="min-h-screen bg-gradient-to-br from-slate-900 via-stone-900 to-slate-950">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Prices" element={<Prices />} />
            <Route path="/TOS" element={<TOS />} />
            <Route path="/Gallery" element={<Gallery />} />
            <Route path="/Queue" element={<Queue />} />
            <Route path="/Feedback" element={<Feedback />} />
            <Route path="/Commission" element={<Commission />} />
            <Route path="/DiscountOptions" element={<DiscountOptions />} />
            <Route path="/Admin" element={<Admin />} />
          </Routes>
        </div>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
